// export function getOs() {
//     var ua = navigator.userAgent,
//     isWindowsPhone = /(?:Windows Phone)/.test(ua),
//     isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
//     isAndroid = /(?:Android)/.test(ua) || /(?:linux)/.test(ua),
//     isFireFox = /(?:Firefox)/.test(ua),
//     isChrome = /(?:Chrome|CriOS)/.test(ua),
//     isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
//     isPhone = /(?:iPhone)/.test(ua) && !isTablet,
//     isPc = !isPhone && !isAndroid && !isSymbian;
//     return {
//         isTablet: isTablet,
//         isPhone: isPhone,
//         isAndroid : isAndroid,
//         isMobile: isPhone || isAndroid,
//         isPc : isPc
//     };
// }

export function getOs() {
  var UA = window.navigator.userAgent.toLowerCase();

  if (UA.indexOf("android") > -1 || UA.indexOf("linux") > -1) {
    return "android";
  }
  if (/\b(iphone|ipad)\b/i.test(UA)) {
    return "ios";
  }
  if (/\b(os X|windows)\b/i.test(UA)) {
    return "pc";
  }
  if (/micromessenger/i.test(UA)) {
    return "wechat";
  }
  return "";
}

export function isMobile() {
  var regex_match = /(nokia|iphone|android|motorola|^mot-|softbank|foma|docomo|kddi|up.browser|up.link|htc|dopod|blazer|netfront|helio|hosin|huawei|novarra|CoolPad|webos|techfaith|palmsource|blackberry|alcatel|amoi|ktouch|nexian|samsung|^sam-|s[cg]h|^lge|ericsson|philips|sagem|wellcom|bunjalloo|maui|symbian|smartphone|midp|wap|phone|windows ce|iemobile|^spice|^bird|^zte-|longcos|pantech|gionee|^sie-|portalmmm|jigs browser|hiptop|^benq|haier|^lct|operas*mobi|opera*mini|320x320|240x320|176x220)|linux/i;
  var u = navigator.userAgent;
  if (null == u) {
    return true;
  }
  var result = regex_match.exec(u);

  if (null == result) {
    return false;
  } else {
    return true;
  }
}

export default { getOs, isMobile };
